
/* RequestRoburCertificate */

export class RoburCertificationRequest {

    public name: string;
    public surname: string;
    public company: string;
    public email: string;
    public productCode: string;
    public batchCode: string;
    public phone: string;
    // public captcha: string;
    public language: string;
    public certificateLanguage: string;
}

export enum RoburCertificationRequestResult {

    ResultErrorHttp = -1,
    ResultOk = 0,
    ResultInvalidInput = 1,
    ResultInvalidCaptcha = 2,
    ResultGenericError = 3,
    ResultNotFound = 4,
    ResultOkWrongLanguage = 5
}

export class ContactSalesRequest {

    public name: string;
    public surname: string;
    public phone: string;
    public company: string;
    public email: string;
    public productCode: string;
    public batchCode: string;

}

export enum ContactSalesRequestResult {

    Ok = 6,
    InvalidInput = 1,
    GenericError = 3

}



// WEBPACK FOOTER //
// ./src/app/models.ts